import React, {useEffect, useState} from "react";
import {SunIcon, MoonIcon} from "@heroicons/react/24/outline";

import {Button} from "./ui/button";

const DarkModeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // On component mount, check if dark mode is already enabled in local storage
    const darkModePreference = localStorage.getItem("dark-mode") === "true";
    setIsDarkMode(darkModePreference);
    document.documentElement.classList.toggle("dark", darkModePreference);
  }, []);

  const toggleDarkMode = () => {
    setIsDarkMode((prevMode) => {
      const newMode = !prevMode;
      localStorage.setItem("dark-mode", newMode); // Save preference to local storage
      document.documentElement.classList.toggle("dark", newMode);
      return newMode;
    });
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleDarkMode}
      aria-label={isDarkMode ? "Switch to day edition" : "Switch to night edition"}
      title={isDarkMode ? "Day edition" : "Night edition"}
    >
      {isDarkMode ? (
        <SunIcon className="size-5" />
      ) : (
        <MoonIcon className="size-5" />
      )}
    </Button>
  );
};

export default DarkModeToggle;
